module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conclusion"
  }, [_c('div', {
    staticClass: "ground"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "conclusion-table"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "conclusion-print"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/imprimante.png")
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.clickPrint
    }
  }, [_c('svg', [_c('use', {
    attrs: {
      "xlink:href": "#print"
    }
  })]), _vm._v("Imprimer la liste")])])]), _vm._v(" "), _c('div', {
    staticClass: "conclusion-mention"
  }, [_c('svg', [_c('use', {
    attrs: {
      "xlink:href": "#attention"
    }
  })]), _vm._v(" Le médicament n'est pas un produit comme les autres, pour en savoir plus rapprochez-vous\nde votre médecin traitant ou votre pharmacien\n    ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_vm._v("3")]), _c('span', [_vm._v("Imprimez votre liste :")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conclusion-label"
  }, [_c('div', {
    staticClass: "conclusion-label__text"
  }, [_vm._v("Femme enceinte")]), _vm._v(" "), _c('div', {
    staticClass: "conclusion-label__text"
  }, [_vm._v("Adulte avec de jeunes enfants")]), _vm._v(" "), _c('div', {
    staticClass: "conclusion-label__text"
  }, [_vm._v("Couple")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conclusion-img"
  }, [_c('div', {
    staticClass: "conclusion-img__img"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/femme_enceinte.png"),
      "width": "185"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "conclusion-img__img"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/homme_enfants.png"),
      "width": "255"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "conclusion-img__img"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/couple.png"),
      "width": "295"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conclusion-list"
  }, [_vm._v("\n        INCONTOURNABLES\n        "), _c('ul', {
    staticClass: "conclusion-incontournables"
  }), _vm._v("\n        OPTIONNELS\n        "), _c('ul', {
    staticClass: "conclusion-optionnels"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c701d606","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/4-Conclusion.vue
// module id = 119
// module chunks = 1